import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LandingPage } from './pages/LandingPage';
import { AppGate } from './pages/AppGate';
import { OnboardingPage } from './pages/OnboardingPage';
import { ErrorBoundary } from './components/ErrorBoundary';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <Toaster
        position="bottom-right"
        richColors
        closeButton
        toastOptions={{
          duration: 4000,
          style: { fontFamily: 'Inter, sans-serif' },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/a/invitar/:token" element={<ErrorBoundary><OnboardingPage /></ErrorBoundary>} />
          <Route path="/a" element={<ErrorBoundary><AppGate /></ErrorBoundary>} />
          <Route path="/a/*" element={<ErrorBoundary><AppGate /></ErrorBoundary>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
